export const bookingImportConstants = {
    BOOKING_IMPORT_SETUP_PENDING: 'BOOKING_IMPORT_SETUP_PENDING',
    BOOKING_IMPORT_SETUP_FULFILLED: 'BOOKING_IMPORT_SETUP_FULFILLED',
    BOOKING_IMPORT_SETUP_REJECTED: 'BOOKING_IMPORT_SETUP_REJECTED',
    BOOKING_IMPORT_STATUS_PENDING: 'BOOKING_IMPORT_STATUS_PENDING',
    BOOKING_IMPORT_STATUS_FULFILLED: 'BOOKING_IMPORT_STATUS_FULFILLED',
    BOOKING_IMPORT_STATUS_REJECTED: 'BOOKING_IMPORT_STATUS_REJECTED',
    BOOKING_IMPORT_CHECK_PENDING: 'BOOKING_IMPORT_CHECK_PENDING',
    BOOKING_IMPORT_CHECK_FULFILLED: 'BOOKING_IMPORT_CHECK_FULFILLED',
    BOOKING_IMPORT_CHECK_REJECTED: 'BOOKING_IMPORT_CHECK_REJECTED',
    BOOKING_PHOTO_SEARCH_PENDING: 'BOOKING_PHOTO_SEARCH_PENDING',
    BOOKING_PHOTO_SEARCH_FULFILLED: 'BOOKING_PHOTO_SEARCH_FULFILLED',
    BOOKING_PHOTO_SEARCH_REJECTED: 'BOOKING_PHOTO_SEARCH_REJECTED',
    BOOKING_PHOTO_SAVE_PENDING: 'BOOKING_PHOTO_SAVE_PENDING',
    BOOKING_PHOTO_SAVE_FULFILLED: 'BOOKING_PHOTO_SAVE_FULFILLED',
    BOOKING_PHOTO_SAVE_REJECTED: 'BOOKING_PHOTO_SAVE_REJECTED',
    BOOKING_FACILITY_SEARCH_PENDING: 'BOOKING_FACILITY_SEARCH_PENDING',
    BOOKING_FACILITY_SEARCH_FULFILLED: 'BOOKING_FACILITY_SEARCH_FULFILLED',
    BOOKING_FACILITY_SEARCH_REJECTED: 'BOOKING_FACILITY_SEARCH_REJECTED',
    BOOKING_FACILITY_SAVE_PENDING: 'BOOKING_FACILITY_SAVE_PENDING',
    BOOKING_FACILITY_SAVE_FULFILLED: 'BOOKING_FACILITY_SAVE_FULFILLED',
    BOOKING_FACILITY_SAVE_REJECTED: 'BOOKING_FACILITY_SAVE_REJECTED',
    BOOKING_IMPORT_CLEAR: 'BOOKING_IMPORT_CLEAR',
    BOOKING_PHOTO_CLEAR: 'BOOKING_PHOTO_CLEAR',
    BOOKING_FACILITY_CLEAR: 'BOOKING_FACILITY_CLEAR',
};
